<template>
  <div
    @click="onClick"
    class="ba-flex ba-items-center ba-text-sm ba-text-label ba-cursor-pointer"
  >
    <div
      class="ba-flex ba-items-center ba-justify-center ba-flex-shrink-0 ba-mr-2"
    >
      <vis-logout-icon />
    </div>
    <div class="ba-whitespace-no-wrap ba-truncate">
      {{ label || $t("changeAccount") }}
    </div>
  </div>
</template>

<script>
import VisLogoutIcon from "./vis-logout-icon";
import { identityApi } from "@ba/visary-account-common-vue";

export default {
  name: "vis-logout-label",
  components: {
    VisLogoutIcon
  },
  props: {
    state: {
      type: String,
      required: true
    },
    token: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  methods: {
    onClick() {
      identityApi.account2.logoutRedirect(this.state, this.token);
    }
  }
};
</script>
